import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { avoidFavorSetSchema } from '../schemas/avoid-favor-set.schema';
import { fleetMessageSchema } from '../schemas/fleet-message.schema';

/**
 * Gets Avoid Favor Sets assigned to a specific vehicle group
 * @param vehicleGroupId Vehicle Group ID of group whose Avoid Favor Sets are being requested
 * @returns Array of IDs
 */
export function getVehicleGroupsIdAvoidFavorSets(
  this: unknown,
  vehicleGroupId: number
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${
          fleetEnvironment.resolve(this).avoidFavorSetsVehicleGroupsUrl
        }?vehicleGroupIds=${String(vehicleGroupId)}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      fleetMessageSchema.extend({
        data: z.array(avoidFavorSetSchema.omit({ vehicleGroups: true })),
      })
    )
  );
}
